import LegalLayout from '../components/legal/LegalLayout';

export default function CookiePage() {
  return <LegalLayout title="Cookie policy" dataId="db770b26-f12b-412b-be11-8d5ada6913f0" />;
}
